import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Global image error handler — gracefully hide broken images
window.addEventListener('error', (e) => {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'IMG') {
    (target as HTMLImageElement).style.display = 'none';
  }
}, true);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)